<br />
<div class="row-header" fxLayout="row wrap" fxFlex="100%;">
  <div
    class="row-wrap"
    fxLayout="row wrap"
    fxFlex="65%;"
    fxFlex.xs="100%;"
    fxFlex.lt-md="100%;"
    fxLayout.xs="row wrap"
  >
    <bci-breadcrumbs>
      <bci-breadcrumb
        *ngFor="let breadcrumb of customBreadcrumbs | async"
        [title]="breadcrumb"
        style="
          text-align: center;
          line-height: 50px;
          margin-top: 1em;
          cursor: pointer;
          color: #008ecf;
        "
        (click)="customBreadcrumbClicked(breadcrumb)"
      ></bci-breadcrumb>
    </bci-breadcrumbs>

    <div
      id="wrapper"
      style="text-align: center; width: 98%; margin: 1rem"
    ></div>
    <div style="width: 98%; margin: 1rem" *ngIf="hasImageData">
      <label
        class="margin-2 sensorLastUpdatedTxtime"
        *ngIf="sensorData && sensorData.length > 0"
        >{{ sensorLastUpdatedTxtime }}</label
      >
      <div
        class="row legend"
        *ngIf="!displayHydraulicDataTable"
        style="margin-top: 1em"
      >
        <div class="col-md-7" style="padding-left: 4%">
          <div class="col-md-4">
            <div
              class="pull-left label"
              style="background-color: #00677f; margin-top: 2px"
            >
              &nbsp;&nbsp;&nbsp;
            </div>
            <div class="pull-left margin-2" style="margin-left: 1px">
              {{ 'virtualNavigation.level' | translate }}
            </div>
          </div>
          <div class="col-md-3">
            <div
              class="pull-left label"
              style="background-color: #19d4ff; margin-top: 2px"
            >
              &nbsp;&nbsp;&nbsp;
            </div>
            <div class="pull-left margin-2" style="margin-left: 2px">
              {{ 'virtualNavigation.sensor' | translate }}
            </div>
          </div>
          <div class="col-md-3">
            <div
              class="pull-left label"
              style="background-color: #428bca; margin-top: 2px"
            >
              &nbsp;&nbsp;&nbsp;
            </div>
            <div class="pull-left margin-2" style="margin-left: 4px">
              {{ 'virtualNavigation.load' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="dashboard-row-wrapper"
    fxLayout="row wrap"
    fxFlex="35%;"
    fxFlex.xs="100%;"
    fxFlex.lt-md="100%;"
    fxLayoutAlign="flex-start flex-start"
  >
    <div
      class="dashboard-wrapper alert-container"
      id="alert-container"
      fxFlex="100%;"
      fxLayout="row wrap"
    >
      <div class="header-title">
        {{ 'virtualNavigation.alerts' | translate }}
      </div>
      <div
        id="header-container"
        fxLayout="row wrap"
        fxFlex="100%;"
        fxLayoutAlign="flex-start flex-start"
      >
        <div
          id="row-icon-overview"
          fxFlex="33.3%;"
          fxLayout="row wrap"
          fxLayoutAlign="center flex-start"
        >
          <div fxFlex="40%;" style="flex: 40%">
            <img
              class="overview-icon"
              src="./assets/img/dashboard/calendar-today-icon.png"
              alt="Today"
            />
          </div>
          <div
            id="alert-value-calender"
            fxFlex="50%;"
            fxLayout="row wrap"
            fxLayoutAlign="center flex-start"
          >
            <div fxFlex="100%;" class="alert-value" style="flex: 100%">
              {{ todayAlert }}
            </div>
            <div fxFlex="100%;" class="alert-canlendar" style="flex: 100%">
              {{ 'virtualNavigation.today' | translate }}
            </div>
          </div>
        </div>
        <div
          id="icon-overview"
          fxFlex="33.3%;"
          fxLayout="row wrap"
          fxLayoutAlign="center flex-start"
        >
          <div fxFlex="40%;" style="flex: 40%">
            <img
              class="overview-icon"
              src="./assets/img/dashboard/calendar-week-icon.png"
              alt="Week"
            />
          </div>
          <div
            id="alert-calender-value"
            fxFlex="50%;"
            fxLayout="row wrap"
            fxLayoutAlign="center flex-start"
          >
            <div fxFlex="100%;" class="alert-value" style="flex: 100%">
              {{ thisWeekAlert }}
            </div>
            <div fxFlex="100%;" class="alert-canlendar" style="flex: 100%">
              {{ 'virtualNavigation.week' | translate }}
            </div>
          </div>
        </div>
        <div
          id="row-month-alert-value-calender"
          fxFlex="33.3%;"
          fxLayout="row wrap"
          fxLayoutAlign="center flex-start"
        >
          <div fxFlex="40%;" style="flex: 40%">
            <img
              class="overview-icon"
              src="./assets/img/dashboard/calendar-month-icon.png"
              alt="Month"
            />
          </div>
          <div
            id="month-alert-value-calender"
            fxFlex="50%;"
            fxLayout="row wrap"
            fxLayoutAlign="center flex-start"
          >
            <div fxFlex="100%;" class="alert-value" style="flex: 100%">
              {{ thisMonthAlert }}
            </div>
            <div fxFlex="100%;" class="alert-canlendar" style="flex: 100%">
              {{ 'virtualNavigation.month' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    LOAD READINGS - [ RealTimePower, Voltage, Current, PowerFactor ] -->
    <div
      class="dashboard-wrapper alert-container"
      id="alert-row-load"
      fxFlex="100%;"
      fxLayout="row wrap"
      *ngIf="rtDataLength > 0"
    >
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <fieldset class="scheduler-border">
            <legend
              class="scheduler-border"
              style="background-color: #428bca; color: white; cursor: pointer"
              data-ng-click="deepDiveInfo()"
              title="Click to View Electrical Trends "
            >
              {{ meterName }}&nbsp;&nbsp;
              <a
                class="floatRight"
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                style="color: white"
                ><i class="fa fa-bar-chart" aria-hidden="true"></i
              ></a>
            </legend>
            <br />
            <div class="row">
              <div
                class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                *ngFor="let key of objectKeys(loadRTData)"
              >
                <section
                  class="box-typical"
                  role="button"
                  tabindex="0"
                  style="background-color: #f5f5f5; color: #7f7f7f"
                >
                  <label
                    style="
                      max-width: 40px;
                      font-size: 15px;
                      font-weight: bold;
                      height: 30px;
                      line-height: 45px;
                      padding-left: 8px;
                    "
                    >{{ key }}</label
                  >
                  <footer
                    class="box-typical-header-sm bordered"
                    style="
                      background-color: white;
                      height: 65px;
                      line-height: 40px;
                    "
                  >
                    <label
                      style="font-size: 21px; font-weight: bold"
                      *ngIf="loadRTData[key] !== null"
                      >{{ loadRTData[key] }}&nbsp;{{ units[key] }}</label
                    >
                  </footer>
                </section>
              </div>
            </div>
            <label>
              {{ 'virtualNavigation.electricalData' | translate }}
              {{ txtime }}</label
            >
          </fieldset>
        </div>
      </div>
    </div>

    <div
      id="header-graph-container"
      fxLayout="row wrap"
      fxFlex="100%;"
      fxFlex.xs="100%;"
      fxFlex.lt-md="100%;"
      fxLayoutAlign="flex-start flex-start"
    >
      <div
        id="container-graph"
        fxLayout="row wrap"
        fxFlex="50%;"
        fxFlex.xs="100%;"
        fxFlex.lt-md="100%;"
        fxLayoutAlign="flex-start flex-start"
      >
        <div
          *ngFor="let sensor of oddSensors; let $index = index"
          id="oddGraphChart_{{ $index }}"
          class="dashboard-wrapper graph-container"
          fxFlex="100%;"
          fxLayout="row wrap"
        >
          <div
            id="odd-graph-chart"
            fxLayout="row"
            fxLayoutAlign="flex-end flex-end"
            fxFlex.xs="100%;"
          >
            <button (click)="changeToBar('oddGraphChart_', $index)">
              <img
                id="imgBar_oddGraphChart_{{ $index }}"
                src="./assets/img/barIcon.png"
                srcset="
                  ./assets/img/barIcon@2x.png 2x,
                  ./assets/img/barIcon@3x.png 3x
                "
                class="bar-icon"
                alt="Bar Chart"
              />
            </button>
            <button (click)="changeToLine('oddGraphChart_', $index)">
              <img
                id="imgLine_oddGraphChart_{{ $index }}"
                src="./assets/img/lineGrayIcon.png"
                srcset="
                  ./assets/img/lineIcon@2x.png 2x,
                  ./assets/img/lineIcon@3x.png 3x
                "
                class="line-icon"
                alt="Line Chart"
              />
            </button>
          </div>
        </div>
      </div>

      <div
        id="row-even-graph-container"
        fxLayout="row wrap"
        fxFlex="50%;"
        fxFlex.xs="100%;"
        fxFlex.lt-md="100%;"
        fxLayoutAlign="flex-start flex-start"
      >
        <div
          *ngFor="let sensor of evenSensors; let $index = index"
          id="evenGraphChart_{{ $index }}"
          class="dashboard-wrapper graph-container"
          fxFlex="100%;"
          fxLayout="row wrap"
        >
          <div
            id="even-graph-container"
            fxLayout="row"
            fxLayoutAlign="flex-end flex-end"
            fxFlex.xs="100%;"
          >
            <button (click)="changeToBar('evenGraphChart_', $index)">
              <img
                id="imgBar_evenGraphChart_{{ $index }}"
                src="./assets/img/barIcon.png"
                srcset="
                  ./assets/img/barIcon@2x.png 2x,
                  ./assets/img/barIcon@3x.png 3x
                "
                class="bar-icon"
                alt="Bar Chart"
              />
            </button>
            <button (click)="changeToLine('evenGraphChart_', $index)">
              <img
                id="imgLine_evenGraphChart_{{ $index }}"
                src="./assets/img/lineGrayIcon.png"
                srcset="
                  ./assets/img/lineIcon@2x.png 2x,
                  ./assets/img/lineIcon@3x.png 3x
                "
                class="line-icon"
                alt="Line Chart"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    id="hidden-box-to-check-text-width"
    style="
      position: absolute;
      font-size: 14px;
      font-weight: bold;
      visibility: hidden;
      height: auto;
      width: auto;
      white-space: nowrap;
    "
  ></div>
</div>
